module.exports = __webpack_public_path__ + "img/icon_map_default.64d2e7f5.png";